/**
 * Section B7.1 Service - B.7.1.日常與基準計算
 */
import axios from '../api/axios';

const BASE_URL = '/api/section-b7-1';

// ── 公式 JSON 結構 ────────────────────────────────────────────────
export interface FormulaParameter {
  symbol: string;
  para_type?: number | null;    // Baseline only
  scenarios: string;             // BAU: HTML rich text; Baseline: plain text
  unit: string;                  // LaTeX syntax
  annual_value: number | null;
}

export interface FormulaEntry {
  id: string;
  methodology: string;
  equation: { latex: string };
  parameters: FormulaParameter[];
  calculation_result: { value: number | null; unit: string };
  is_sampling: boolean;
  sample_plans: string;
}

// ── 主資料表 ─────────────────────────────────────────────────────
export interface SectionB71Detail {
  id: number;
  organization_id: number;
  project_id: number;
  bau_calculate: FormulaEntry[] | null;
  baseline_calculate: FormulaEntry[] | null;
  diff_calculate: number | null;
  is_baselined: boolean;
  is_downward: boolean;
  downward_descript: string | null;
  b7_1: number;
  edit_by: number | null;
  created_at: string;
  updated_at: string | null;
}

export interface SectionB71Update {
  diff_calculate?: number | null;
  is_baselined?: boolean;
  is_downward?: boolean;
  downward_descript?: string;
}

// ── API 函式 ──────────────────────────────────────────────────────
export const getSectionB71ByProject = async (projectId: number): Promise<SectionB71Detail | null> => {
  const response = await axios.get<SectionB71Detail>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

export const updateSectionB71 = async (projectId: number, data: SectionB71Update): Promise<SectionB71Detail> => {
  const response = await axios.put<SectionB71Detail>(`${BASE_URL}/${projectId}`, data);
  return response.data;
};

// BAU (B.7.1.1)
export const addBauFormula = async (projectId: number, entry: FormulaEntry): Promise<SectionB71Detail> => {
  const response = await axios.post<SectionB71Detail>(`${BASE_URL}/${projectId}/bau`, entry);
  return response.data;
};

export const updateBauFormula = async (projectId: number, entryId: string, entry: FormulaEntry): Promise<SectionB71Detail> => {
  const response = await axios.put<SectionB71Detail>(`${BASE_URL}/${projectId}/bau/${entryId}`, entry);
  return response.data;
};

export const deleteBauFormula = async (projectId: number, entryId: string): Promise<void> => {
  await axios.delete(`${BASE_URL}/${projectId}/bau/${entryId}`);
};

// Baseline (B.7.1.2)
export const addBaselineFormula = async (projectId: number, entry: FormulaEntry): Promise<SectionB71Detail> => {
  const response = await axios.post<SectionB71Detail>(`${BASE_URL}/${projectId}/baseline`, entry);
  return response.data;
};

export const updateBaselineFormula = async (projectId: number, entryId: string, entry: FormulaEntry): Promise<SectionB71Detail> => {
  const response = await axios.put<SectionB71Detail>(`${BASE_URL}/${projectId}/baseline/${entryId}`, entry);
  return response.data;
};

export const deleteBaselineFormula = async (projectId: number, entryId: string): Promise<void> => {
  await axios.delete(`${BASE_URL}/${projectId}/baseline/${entryId}`);
};

// Reset 全部資料
export const resetSectionB71 = async (projectId: number): Promise<void> => {
  await axios.post(`${BASE_URL}/${projectId}/reset`);
};

const sectionB71Service = {
  getSectionB71ByProject,
  updateSectionB71,
  resetSectionB71,
  addBauFormula, updateBauFormula, deleteBauFormula,
  addBaselineFormula, updateBaselineFormula, deleteBaselineFormula,
};
export default sectionB71Service;
